export default "__VITE_ASSET__BlzqhryB__"